<template>
  <Portal>
    <div
      v-if="show"
      :class="{ 'loader-modal__lock-overlay': lockOverlay }"
      class="loader-modal"
    >
      <transition name="fade-fast">
        <Overlay v-if="show" class="loader-modal--overlay" />
      </transition>

      <transition name="alert" appear>
        <div v-if="show" class="loader-modal-content">
          <slot name="text-content">
            <Icon
              :icon="icon"
              :class="`loader-modal-content--icon__${sizeIcon}`"
              class="loader-modal-content--icon"
            />

            <Heading level="1">{{ title }}</Heading>

            <p class="loader-modal-content--text">
              <slot name="text">
                {{ text }}
              </slot>
            </p>
          </slot>

          <slot name="actions">
            <PmwLoader class="loader" />
          </slot>
        </div>
      </transition>
    </div>
  </Portal>
</template>

<script>
/**
 * * Componente de modal com loader
 */

import { Portal } from '@linusborg/vue-simple-portal' /** https://github.com/LinusBorg/vue-simple-portal */
import { lockBodyScroll, unlockBodyScroll } from '@/helpers/dom'
import Heading from '../elements/Heading'
import Overlay from '../elements/Overlay'
import PmwLoader from '@/components/_base/elements/PmwLoader'

export default {
  name: 'LoaderModal',
  components: {
    PmwLoader,
    Heading,
    Overlay,
    Portal
  },
  props: {
    /** Estado da renderização */
    value: {
      type: Boolean,
      default: false
    },
    /** Ícone usado */
    icon: {
      type: String,
      default: 'bell-outline' /** Sino */
    },
    /** Tamanho do ícone usado - Opções: small/large */
    sizeIcon: {
      type: String,
      default: 'small'
    },
    /** Título */
    title: {
      type: String,
      default: 'Atenção'
    },
    /** Texto descritivo */
    text: {
      type: String,
      default: 'Aguarde enquanto salvamos as informações. '
    },
    /** Bloqueia o clique no overlay */
    lockOverlay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show() {
      return this.value
    }
  },
  watch: {
    /**
     * Observa o estado da renderização para
     * habilitar ou desabilitar o scroll do body
     */
    value(newValue) {
      if (newValue) {
        /** Desabilita o scroll do body */
        lockBodyScroll()
      } else {
        /** Habilita o scroll do body */
        unlockBodyScroll()
      }
    }
  },
  methods: {
    openModal() {
      this.$emit('input', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.loader-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: $modal-z-index;

  &__lock-overlay {
    .overlay {
      pointer-events: none;
    }
  }

  &-content {
    position: absolute;
    width: 510px;
    max-height: 80vh;
    padding: 45px 30px 25px 30px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: $white;
    text-align: center;
    color: $gray-darkest;
    @include drop-shadow(0px 20px 40px rgba(0, 0, 0, 0.15));

    &--icon {
      width: auto;
      margin-bottom: 35px;
      color: $orange;
      &__small {
        height: 60px;
      }
      &__large {
        height: 100px;
      }
    }

    .heading {
      margin-bottom: 15px;
    }

    &--text {
      line-height: 26px;
      margin-bottom: 25px;

      p {
        margin: 0;
      }
    }

    .loader {
      margin-top: 40px;
      margin-bottom: 20px;
    }
  }
}
</style>
